import type { ReactNode } from 'react';
import styles from './admin-log.module.scss';

interface MetaItemProps {
  label: string;
  children: ReactNode;
}

/**
 * One labelled value in an admin log's expanded-row detail grid.
 * @param {MetaItemProps} props - The label and the value shown under it
 * @return {JSX.Element} The labelled value
 */
export function MetaItem({ label, children }: MetaItemProps) {
  return (
    <div className={styles.metaItem} role="group" aria-label={label}>
      <span className={styles.metaLabel}>{label}</span>
      <span className={styles.metaValue}>{children}</span>
    </div>
  );
}
